/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  chipHolderRow: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "0.5rem",
    marginBottom: "1rem",
  },
  skeletonChipHolderRow: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "0.5rem",
  },
  chip: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#E8E8E8",
    padding: "0.125rem 0.5rem 0.125rem 0.5rem",
    borderRadius: "4px",
    whiteSpace: "nowrap",
  },
  chipText: {
    fontWeight: 500,
    fontSize: "0.75rem",
    lineHeight: "1.125rem",
    color: "#202020",
  },
  skeletonContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
  },
  chipSkeleton: {
    width: "10%",
    height: "auto",
    margin: "1rem 0.5rem 1rem 0rem",
    "&.MuiSkeleton-text": {
      transform: "none",
    },
  },
}));

const PICChips = (props) => {
  const classes = useStyles();

  if (!props.loading) {
    return (
      <React.Fragment>
        <div className={classes.chipHolderRow}>
          {props.chips.map((chip, key) => {
            return (
              <div key={key} className={classes.chip}>
                <Typography
                  variant="body2"
                  component="span"
                  className={classes.chipText}
                >
                  {chip.label}
                </Typography>
              </div>
            );
          })}
        </div>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className={classes.skeletonContainer}>
          <Skeleton className={classes.chipSkeleton} />
          <Skeleton className={classes.chipSkeleton} />
          <Skeleton className={classes.chipSkeleton} />
          <Skeleton className={classes.chipSkeleton} />
        </div>
      </React.Fragment>
    );
  }
};

export default PICChips;
